"use client";

import React, { useState } from "react";
import styles from "./FaqSection.module.css";

interface Faq {
  title: string;
  article: string;
}

const allFaqs: Faq[] = [
  {
    title: "What is Temok’s Reseller Partner Program?",
    article:
      "Temok’s Reseller Partner Program allows you to resell enterprise-grade hosting, cloud, and infrastructure services under your own brand while Temok manages the backend operations."
  },
  {
    title: "Who can join the Reseller Partner Program?",
    article:
      "IT companies, web agencies, MSPs, freelancers, and entrepreneurs looking to expand their service offerings without managing infrastructure can join the program."
  },
  {
    title: "What services can I resell through Temok?",
    article:
      "You can resell Managed Cloud Servers, Shared Hosting, VPS, Dedicated Servers, Domains, SSL Certificates, Proxies, and VPN services."
  },
  {
    title: "Does Temok support white-label reselling?",
    article:
      "Yes. Temok fully supports white-label reselling, enabling you to sell services under your own brand while leveraging Temok’s robust infrastructure."
  },
  {
    title: "What kind of support do Reseller Partners receive?",
    article:
      "Reseller Partners receive priority support, including access to a dedicated account manager and 24/7 technical assistance."
  },
  {
    title: "Are marketing resources provided?",
    article:
      "Yes. Partners receive access to banners, promotional materials, and expert guidance to help grow their business."
  },
  {
    title: "How does billing and payment work?",
    article:
      "Temok offers flexible billing and payment options, allowing partners to manage costs efficiently while scaling their business."
  },
  {
    title: "Do Reseller Partners earn commissions?",
    article:
      "Yes. Partners earn lucrative commissions on every successful sale, ensuring a sustainable revenue stream."
  },
  {
    title: "Are training sessions provided?",
    article:
      "Regular training sessions and product updates are provided to keep partners informed about the latest technologies."
  },
  {
    title: "Can I create customized service bundles?",
    article:
      "Partners can create customized service bundles by combining Temok’s services with their own value-added offerings."
  },
  {
    title: "Do you provide reporting and analytics?",
    article:
      "Yes. Transparent reporting and analytics help partners track performance and make data-driven decisions."
  },
  {
    title: "Are exclusive promotions available?",
    article:
      "Reseller Partners receive access to exclusive promotions and discounts to attract and retain clients."
  }
];

const INITIAL_COUNT = 6;
const LOAD_MORE_COUNT = 3;

const FaqSection: React.FC = () => {
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);

  const handleLoadMore = () => {
    setVisibleCount((prev) =>
      Math.min(prev + LOAD_MORE_COUNT, allFaqs.length)
    );
  };

  return (
    <section className={`container-lg ${styles.faqSection}`}>
      <h4 className={styles.title}>Frequently Asked Questions</h4>

      <div
        className={`${styles.accordionWrap} accordion mt-4`}
        id="faqAccordion"
      >
        {allFaqs.slice(0, visibleCount).map((item, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq-${index}`}
                aria-expanded="false"
                aria-controls={`faq-${index}`}
              >
                {item.title}
              </button>
            </h2>

            <div
              id={`faq-${index}`}
              className="accordion-collapse collapse"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body p-3">
                {item.article}
              </div>
            </div>
          </div>
        ))}
      </div>

      {visibleCount < allFaqs.length && (
        <div className={styles.loadMoreWrap}>
          <button
            className={styles.loadMoreBtn}
            onClick={handleLoadMore}
          >
            Load More FAQs
          </button>
        </div>
      )}
    </section>
  );
};

export default FaqSection;
